import { render, staticRenderFns } from "./PaymentPreferences.vue?vue&type=template&id=569cf03e"
import script from "./PaymentPreferences.vue?vue&type=script&lang=js"
export * from "./PaymentPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports